import React from 'react';
import StoreIcon from '@mui/icons-material/Store';
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';

export const customLocationVariable = {
  access: 1,
  dataset: 'Base Data Pack',
  description: 'Custom',
  national_count: 0,
  table_id: 'loc',
  table_name: 'Geography',
  theme: 'Location',
  value_id: '11',
  var_id: 'loc_custom',
  var_values: 'Custom Location',
};

export const searchInfoMessages = [
  {
    title: 'We can’t find keyword entered.',
    subtitle:
      'Make sure the location name is correct. Try searching for a nearby city or landmark.',
  },
  {
    title: 'Keep typing to see search results.',
    subtitle: 'Please provide more details to refine your search results.',
  },
];

export const locationTypes = {
  stores: {
    optionText: 'Stores',
    optionIcon: <StoreIcon fontSize="small"/>
  },
  ooh: {
    optionText: 'OOH',
    optionIcon: <ContactPhoneOutlinedIcon fontSize="small"/>
  }
};

export const radiusValues = {
  'ca': {
    values: [
      { value: 0.5 },
      { value: 1 },
      { value: 2 },
      { value: 5 },
      { value: 10 },
    ],
    unitOfMeasure: 'km'
  },
  'us': {
    values: [
      { value: 0.25 },
      { value: 0.5 },
      { value: 1 },
      { value: 3 },
      { value: 5 },
    ],
    unitOfMeasure: 'miles'
  }
}